import '@ionic/core';

export default function () {}
